import { render, staticRenderFns } from "./cencenlInterview.vue?vue&type=template&id=efb07d60&scoped=true&"
import script from "./cencenlInterview.vue?vue&type=script&lang=js&"
export * from "./cencenlInterview.vue?vue&type=script&lang=js&"
import style0 from "./cencenlInterview.vue?vue&type=style&index=0&id=efb07d60&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb07d60",
  null
  
)

export default component.exports